// extracted by mini-css-extract-plugin
module.exports = {"cardsBlock":"MtDownloadLinks_cardsBlock__ECG4_","downloadButton":"MtDownloadLinks_downloadButton__c_Q0Z"};